import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ShortcutCard } from './components/ShortcutCard';
import { ProductPage } from './components/ProductPage';

const AppContainer = styled.div`
  min-height: 100vh;
  padding: 32px;
  background: #1a1a1a;
`;

const SliderContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  .slick-slide {
    padding: 0 10px;
  }
`;

const Title = styled.h1`
  text-align: center;
  color: #fff;
  margin-bottom: 48px;
  font-size: 42px;
  font-weight: 700;
`;

const productsData = {
  windows: {
    title: "Windows 11 Shortcuts",
    icon: "⚡",
    thumbnail: "/thumbnails/windows-11-guide.jpg",
    price: 6.96,
    originalPrice: 19.95,
    buyLink: "#/products/windows11",
    salesPage: "/products/windows11",
    subtitle: "Unlock Its Full Potential with Our Expert Tips, Tricks, and Shortcuts!",
    problem: "Windows 11 is packed with new features, settings, and shortcuts—but let's face it: navigating all of them can feel overwhelming...",
    solution: "Introducing Windows 11 Mastery PDFs—a series of easy-to-follow guides designed to make your life easier.",
    benefits: [
      "Time-saving shortcuts to boost your productivity",
      "Hidden features that most users never find",
      "Step-by-step tips to customize Windows 11 to suit your needs"
    ]
  },
  mac: {
    title: "macOS Shortcuts",
    icon: "💫",
    thumbnail: "/thumbnails/macos-guide.jpg",
    price: 7.95,
    originalPrice: 21.95,
    buyLink: "#/products/macos",
    salesPage: "/products/macos",
    subtitle: "Master Your Mac with Professional Tips & Shortcuts!",
    problem: "macOS is known for its elegance, but its powerful features often remain hidden from everyday users...",
    solution: "Our comprehensive macOS Pro Guide reveals all the secrets of your Mac.",
    benefits: [
      "Powerful keyboard shortcuts for faster workflow",
      "Advanced productivity features and gestures",
      "Professional-level automation techniques"
    ]
  },
  zoom: {
    title: "Zoom Shortcuts",
    icon: "🎥",
    thumbnail: "/thumbnails/zoom-guide.jpg",
    price: 4.95,
    originalPrice: 15.95,
    buyLink: "#/products/zoom",
    salesPage: "/products/zoom",
    subtitle: "Master Virtual Meetings Like a Professional!",
    problem: "Virtual meetings are essential, but managing controls and settings during calls can be overwhelming and distracting...",
    solution: "Our Zoom Shortcuts Guide transforms you into a virtual meeting expert with quick, efficient controls.",
    benefits: [
      "Instant audio/video management shortcuts",
      "Quick screen sharing and presentation controls",
      "Essential meeting moderation shortcuts"
    ]
  }
};

function App() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <AppContainer>
            <Title>KeyWise: All-in-One Shortcuts</Title>
            <SliderContainer>
              <Slider {...settings}>
                {Object.entries(productsData).map(([key, product]) => (
                  <ShortcutCard 
                    key={key}
                    title={product.title}
                    icon={product.icon}
                    thumbnail={product.thumbnail}
                    buyLink={product.salesPage}
                  />
                ))}
              </Slider>
            </SliderContainer>
          </AppContainer>
        } />
        {Object.entries(productsData).map(([key, product]) => (
          <Route 
            key={key}
            path={product.salesPage}
            element={
              <ProductPage
                title={product.title}
                subtitle={product.subtitle}
                problem={product.problem}
                solution={product.solution}
                benefits={product.benefits}
                price={product.price}
                originalPrice={product.originalPrice}
                buyLink={product.buyLink}
              />
            }
          />
        ))}
      </Routes>
    </Router>
  );
}

export default App;